import axios from "../axios";


export const setAllMasterclass = (data) => {
  return {
    type: "SET_ALL_MASTERCLASS",
    payload: data,
  };
};

export const asyncGetAllMasterclass = (query) => {
  return (dispatch) => {
    const url = `/masterclass/get-all-page`;
    const config = {
      params: query,
    };
    axios
      .get(url, config)
      .then((res) => {
        const { data } = res.data;
        dispatch(setAllMasterclass(data));
      })
      .catch((err) => {
        console.log(err.response);
      });
  };
};
